export enum LocalizationId {
    Title = "notifications-modal.title",
    ClearAllButton = "notifications-modal.clear_all_button",
    NoNotificationsTitle = "notifications-modal.no_notifications_title",
    NoNotificationsImage = "notifications-modal.no_notifications_image",
    RemoveNotificationTooltip = "notifications-modal.remove_notification_tooltip",
}
